<template>
  <div>
    <v-alert v-if="showGoogleMapsError" :value="true" class="text-xs-left my-4" type="error">
      {{ $t('failed_to_load_google_maps') }}
      <ul>
        <li>{{ $t('google_maps_fix_suggestions_1') }};</li>
        <li>{{ $t('google_maps_fix_suggestions_2') }};</li>
        <li>{{ $t('google_maps_fix_suggestions_3') }};</li>
        <li>{{ $t('google_maps_fix_suggestions_4') }}.</li>
      </ul>
    </v-alert>
    <v-menu
      v-if="showInMenu"
      v-model="addressMenu"
      :close-on-content-click="false"
      nudge-bottom="4"
      offset-y
      bottom
      left
      min-width="20%"
    >
      <v-btn slot="activator" class="ma-0" color="primary" flat>
        <v-icon left>search</v-icon>
        {{ $t('search_address') }}
      </v-btn>
      <v-card class="search-container px-3 pt-1">
        <v-text-field
          v-model="term"
          :placeholder="placeholder"
          id="address-search"
        />
      </v-card>
    </v-menu>
    <v-text-field
      v-else
      v-model="term"
      :rules="validationRules"
      :placeholder="placeholder"
      :label="$t('address_search')"
      id="address-search"
    />
  </div>
</template>

<script>
/* eslint-disable no-undef */
import formMixin from '../mixins/form-mixin';

export default {
  name: 'AddressSearch',

  props: {
    showInMenu: {
      type: Boolean,
      default: false,
    },
    isRequired: Boolean,
  },

  mixins: [formMixin],

  data() {
    return {
      addressMenu: false,
      term: '',
      placeholder: '',
      showGoogleMapsError: false,
    };
  },

  computed: {
    validationRules() {
      return this.isRequired ? [this.required] : [];
    },
  },

  mounted() {
    this.placeholder = this.$t('enter_address');
    const input = document.getElementById('address-search');

    if (!window.google) {
      this.showGoogleMapsError = true;
      return;
    }

    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'lt' },
    });

    google.maps.event.addDomListener(input, 'keydown', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      if (place && place.address_components) {
        let street;
        let number;
        let city;
        let postCode;
        const components = place.address_components;
        components.forEach((c) => {
          if (c.types.indexOf('street_number') > -1) {
            number = c.short_name;
          } else if (c.types.indexOf('route') > -1) {
            street = c.short_name;
          } else if (c.types.indexOf('locality') > -1) {
            city = c.short_name;
          } else if (c.types.indexOf('postal_code') > -1 && c.short_name) {
            postCode = `LT-${c.short_name}`;
          }
        });
        this.term = '';
        this.addressMenu = false;
        if (!this.showInMenu) {
          this.placeholder = '';
        }
        this.$emit('addressSelected', {
          street,
          number,
          city,
          postCode,
        });
      }
    });
  },
};
</script>

<style scoped>
  .search-container {
    min-height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
